import React, { useEffect, useContext, useState } from 'react';

import { applyFilter } from './DealFilterHelpers';
import { DataContext as DealDataContext } from '../../../stores/crm-deal-store';
import { DataContext as CrmDataContext } from '../../../stores/crm-store';
import EditSelect from '../shared/field_inputs/select/EditSelect';

export const SelectDealFilter = ({ filterKey, optionsName }) => {
    const { store } = useContext(CrmDataContext);
    const allOption = { id: '', name: 'Alla' };
    const options = [allOption].concat(store[optionsName]);
    const {
        store: { apiUrl, defaultFilters, pipelines, currentPipelineId },
        dispatch,
    } = useContext(DealDataContext);

    if (pipelines[currentPipelineId]?.requestObject?.filters[filterKey]) {
        const filterSettings = pipelines[currentPipelineId].requestObject.filters;

        const currentValue = filterSettings[filterKey];

        if (currentValue !== null && pipelines[currentPipelineId].filterOptions[filterKey] === undefined) {
            pipelines[currentPipelineId].filterOptions[filterKey] = options.find((x) => x.id === currentValue);
        }
    }

    const [filterValue, setFilterValue] = useState(
        pipelines[currentPipelineId]?.filterOptions ? pipelines[currentPipelineId].filterOptions[filterKey] : null ?? allOption
    );

    const handleUpdateFilterValue = (value) => {
        pipelines[currentPipelineId].filterOptions[filterKey] = value;
        const newFilterValue = value.id;
        applyFilter(filterKey, newFilterValue, dispatch, pipelines, currentPipelineId);
        setFilterValue(value);
        localStorage.setItem(`deal-filter-${filterKey}`, JSON.stringify(value));
    };

    useEffect(() => {
        if (defaultFilters[filterKey] && pipelines[currentPipelineId]?.filterOptions[filterKey] === null) {
            handleUpdateFilterValue(defaultFilters[filterKey]);
        } else if (pipelines[currentPipelineId]?.filterOptions && pipelines[currentPipelineId].filterOptions[filterKey]) {
            setFilterValue(pipelines[currentPipelineId].filterOptions[filterKey]);
        } else if (pipelines[currentPipelineId]?.filterOptions) {
            setFilterValue(allOption);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pipelines[currentPipelineId]]);

    return (
        <div className='select-filter-container'>
            <EditSelect value={filterValue} setValue={handleUpdateFilterValue} options={options} />
        </div>
    );
};
